import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";

const FactoryAutomationVideoCard_4 = () => {
  return (
    <div className="card w-50 h-auto">
      <div className="card-body bg-dark text-white">
        <h5 className="card-title">Insuline Applicator</h5>
        <p className="card-text">
          This project was what I call real NPI, we were designing and
          integrating the equipment at the same time the customer was designing
          the product. We had to be very flexible and fast to adapt to the
          changes in the product design.
        </p>

        <h6>
          Investment: <span>$2,700,000 USD</span>
        </h6>
        <h6>
          Time to build: <span>12 months</span>
        </h6>
        <h6>
          Savings: <span>Only 5 DL per line, we build 2 lines</span>
        </h6>
        <h6>
          Technology:
          <span>
            Semi Automatic  and Full Automatic stations, 9 Stations, Robots, Visions systems, Bowl
            Feeders, Heat welding System.
          </span>
        </h6>
      </div>
    </div>
  );
};

export default FactoryAutomationVideoCard_4;
